export function NoData() {
  return <div className="font-semibold text-neutrals-N900">--</div>;
}
